import React from "react";

export default function ZigzagIcons({ icons = [] }) {
  return (
    <div className="w-full">
      {/* DESKTOP: горизонтальная версия (показывается на md+) */}
      <div className="hidden md:flex items-start w-full">
        {icons.map((item, i) => {
          const isLast = i === icons.length - 1;

          return (
            <React.Fragment key={i}>
              {/* Icon + label (desktop: centered under icon) */}
              <div className="flex flex-col items-center text-center flex-shrink-0 px-1">
                <img
                  src={item.src}
                  alt={item.label || `icon-${i}`}
                  className="object-contain rounded-3xl w-24 h-24 lg:w-28 lg:h-28 flex-shrink-0"
                />
                <div className="mt-3 text-white font-medium text-sm md:text-base whitespace-pre-line">
                  {item.label}
                </div>
              </div>

              {/* гибкий волновой разделитель */}
              {!isLast && (
                <div className="flex-1 flex items-center px-0 h-24 lg:h-28 mb-6">
                  <svg width="100%" height="40" viewBox="0 0 200 40" preserveAspectRatio="none">
                    <path d="M0 20 C 100 0, 100 40, 200 20" stroke="white" strokeWidth="3" fill="none" strokeLinecap="round" />
                  </svg>
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>

      {/* MOBILE: вертикальная версия (показывается на <md) */}
      <div className="flex flex-col md:hidden items-start w-full">
        {icons.map((item, i) => {
          const isLast = i === icons.length - 1;

          return (
            <React.Fragment key={i}>
              {/* строка: иконка слева, текст сразу справа — всё прижато влево */}
              <div className="w-full flex items-center px-4">
                <img
                  src={item.src}
                  alt={item.label || `icon-${i}`}
                  className="object-contain rounded-2xl lg:rounded-3xl md:rounded-3xl sm:rounded-3xl w-16 h-16 sm:w-20 sm:h-20 flex-shrink-0"
                />
                <div className="ml-4 text-white font-medium text-sm text-left">
                  {item.label}
                </div>
              </div>

              {/* вертикальная волна: расположена под иконкой (сдвинута влево под иконку) */}
              {!isLast && (
                <div className="w-full flex">
                  {/* контейнер шириной равной отступам; настроим margin-left равным ширине иконки + ml-4 */}
                  <div className="sm:ml-14 ml-12 py-0" style={{ width: 'calc(3.5rem)' /* 14px*? use same as w-14 + gaps */ }}>
                    <svg width="8" height="30" viewBox="0 0 10 40" fill="none">
                      <path d="M5 0 C 0 25, 10 25, 5 50" stroke="white" strokeWidth="3" fill="none" strokeLinecap="round" />
                    </svg>
                  </div>
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}